import React from 'react';
import { Icon } from 'rsuite';
import Header from '../../../../../../components/Header';
import { SelectPeriod } from '../SelectPeriod';
import styles from './HeaderAnaliseCobertura.module.scss';

export type HeaderAnaliseCoberturaProps = {
  onChangePeriod: (value: number) => void;
  date?: string;
  status?: number | null;
};

export const HeaderAnaliseCobertura = ({ onChangePeriod, date, status }: HeaderAnaliseCoberturaProps) => {
  return (
    <Header
      subtitle="Analise a cobertura Infopanel para o seu sortimento nos locais desejados."
      badgeLabel="Pro"
      icon={<Icon className={styles['thermometer-icon']} icon="thermometer-3" />}
      titleChildren={
        <div className={styles['header-title-wrapper']}>
          <span className={styles.title}>Análise de Cobertura</span>
          {status === 200 ? (
            <div className={styles['header-update-info']}>
              <span>Atualizado em {date}</span>
            </div>
          ) : null}
        </div>
      }
      rightChildren={
        status === 200 ? (
          <div className={styles['header-right-wrapper']}>
            <SelectPeriod onChange={onChangePeriod} />
          </div>
        ) : null
      }
    />
  );
};
